import * as React from 'react';
import { IconProps } from '../types';

const IcNewCustomer = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
   <path
      fill={props?.fill ?? '#232F3E'}
      d="M11.633 1.081c1.838-.402 3.855.553 4.712 2.226.586 1.09.67 2.435.225 3.59a4.371 4.371 0 0 1-2.17 2.372 4.375 4.375 0 0 1-3.166.248 4.367 4.367 0 0 1-2.617-2.19 4.372 4.372 0 0 1-.034-3.888 4.373 4.373 0 0 1 3.05-2.358Z"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M7.143 11.508c.4-.675.902-1.299 1.545-1.757 1.286 1.102 3.055 1.627 4.73 1.337 1.07-.165 2.067-.669 2.893-1.362.826.612 1.41 1.483 1.872 2.387.644 1.271 1.096 2.63 1.454 4.007a2.482 2.482 0 0 1-.83 2.532c-.51.442-1.198.574-1.856.56-.2 1.197-.876 2.312-1.885 2.996-1.204.848-2.837 1.028-4.2.477-1.458-.562-2.529-1.938-2.775-3.473-.67.014-1.371-.121-1.892-.57-.753-.597-1.096-1.65-.826-2.575.417-1.578.938-3.147 1.77-4.56Zm4.593 3.801c-1.286.289-2.332 1.417-2.51 2.726-.21 1.263.402 2.606 1.487 3.284 1.078.71 2.576.693 3.638-.042 1.305-.846 1.832-2.666 1.179-4.079-.6-1.433-2.288-2.274-3.793-1.889Z"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M11.95 16.77c.128-.48.873-.527 1.07-.076.117.407.043.841.058 1.26.4.006.805-.039 1.2.033.462.143.503.86.065 1.06-.408.122-.846.049-1.266.062-.01.41.048.83-.045 1.233-.173.457-.905.453-1.07-.01-.082-.401-.032-.816-.04-1.224-.417-.011-.85.057-1.255-.054-.451-.191-.416-.93.057-1.068.395-.07.8-.027 1.198-.033.003-.395-.031-.792.028-1.183Z"
    />
  </svg>
);

export default IcNewCustomer;